import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalColetaIndicador from "components/modal/indicadores/ModalColetaIndicador";
import Processo from "model/indicadores/Processo";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import IndicadorMinhasColetasService from "service/indicadores/IndicadorMinhasColetasService";
import IndicadorService from "service/indicadores/IndicadorService";
import { converterData } from "utils/convert";
import { dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";

const indicadorService = new IndicadorService();
const indicadorMinhasColetasService = new IndicadorMinhasColetasService();
export default function IndicadorMinhasColetasListagem() {

    const listagemRef = useRef<BaseListagemRef>(null);
    const [titulo, setTitulo] = useState<string>('Minhas Coletas');
    const navigate = useNavigate();
    const [modalColeta, setModalColeta] = useState<{ visible: boolean, indicadorId: number }>({ visible: false, indicadorId: 0 });

    const [processos, setProcessos] = useState<Processo[]>([]);
    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);

    useEffect(() => {
        indicadorService.processos().then((response) => {
            setProcessos(response);
        }).catch((error) => {
            console.error("Erro ao buscar processos:", error);
        });

        indicadorService.unidadesOrgan().then((response) => {
            setUnidades(response);
        }).catch((error) => {
            console.error("Erro ao buscar unidades organizacionais:", error);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        processo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        unidadeOrganizacional: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataProximaColeta: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }
    return (
        <>
            {modalColeta.visible && <ModalColetaIndicador visible={modalColeta.visible}
                onHide={() => {
                    setModalColeta({ visible: false, indicadorId: 0 });
                    listagemRef.current?.reload();
                }}
                indicadorId={modalColeta.indicadorId}
            />}

            <BaseListagem
                ref={listagemRef}
                ordenacao={"dataProximaColeta,ASC"}
                service={indicadorMinhasColetasService}
                showEditButton={false} showRemoveButton={false} showNewButton={false}
                urlService={"/indicador"}
                tituloPagina={titulo}
                nome="indicadorMinhasColetas"
                defaultFilters={defaultFilters}
                showClearFilterButton
            >
                <Column field="codigo" header="Código" filterField="codigo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="nome" header="Nome" filterField="nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="processo.nome" header="Processo" filter filterField="processo" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, processos)} />
                <Column field="unidadeOrganizacional.nome" header="Unid. Organ." filter filterField="unidadeOrganizacional" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, unidades)} />
                <Column field="dataProximaColeta" body={(rowData) => converterData(rowData.dataProximaColeta)} header="Próxima coleta"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataProximaColeta"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column body={(rowData) => {
                    return <Button icon="pi pi-eye" className="p-button-rounded p-button-info" onClick={() => {
                        navigate(`/indicador/dashboard/${rowData.id}`)
                    }} />
                }} />
                <Column body={(rowData) => {
                    return <Button icon="pi pi-list" className="p-button-rounded p-button-info" onClick={() => {
                        setModalColeta({ visible: true, indicadorId: rowData.id })
                    }} />
                }} />
            </BaseListagem>
        </>
    )
}